import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Layout from 'shared/layouts/Main'
import { Button, Form, Row, Tooltip, OverlayTrigger, InputGroup } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import InputWrapper from 'shared/components/InputWrapper'
import resChangePassword from './resolvers/resChangePassword'
import useInit from './hooks/useInit'
import useFocusError from 'shared/hooks/useFocusError'
import prepareSubmitForm from 'shared/utils/prepareSubmitForm'
import submitForm from './utils/submitForm'
import * as Icon from 'react-bootstrap-icons'
import { togglePasswordInput } from 'utils/passwordUtils'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'

const ChangeConnectionPassword: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [dataLoaded, setDataLoaded] = useState<boolean>(false)

  const [passwordInputType, setPasswordInputType] = useState<string>('password')

  const { id } = useParams()

  const navigate = useNavigate()

  const {
    control,
    register,
    getValues,
    handleSubmit,
    reset,
    setFocus,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: resChangePassword,
  })

  useInit({
    getValues,
    id,
    reset,
    setDataLoaded,
    setShowOverlay,
  })

  useFocusError({
    errors,
    setFocus,
  })

  return (
    <Layout footerContent={<Footer />} brandContent={getBrandContent()} showOverlay={showOverlay}>
      <Form
        onSubmit={handleSubmit((data) =>
          prepareSubmitForm({
            submitForm,
            navigate,
            data,
            setShowOverlay,
            setError: setError,
            id,
            name: 'New Connection Password',
            successNav: '/connections',
          }),
        )}
        id='main-form'
      >
        <InputWrapper label='Name' name='name' errors={errors}>
          <Form.Control disabled={true} type='text' {...register('name')} />
        </InputWrapper>

        <InputWrapper label='New Password' name='password_api' errors={errors}>
          <InputGroup className='mb-3'>
            <Form.Control type={passwordInputType} {...register('password_api')} />

            <OverlayTrigger
              placement='top'
              delay={{ show: 250, hide: 400 }}
              overlay={
                <Tooltip>
                  {passwordInputType === 'password' ? 'Show password' : 'Hide password'}
                </Tooltip>
              }
            >
              <Button
                variant='outline-warning'
                onClick={() => setPasswordInputType(togglePasswordInput(passwordInputType))}
              >
                {passwordInputType === 'password' ? <Icon.Unlock /> : <Icon.Lock />}
              </Button>
            </OverlayTrigger>
          </InputGroup>
        </InputWrapper>

        <Row>
          <div className='update ml-auto mr-auto'>
            <Button disabled={!dataLoaded} type='submit' className='btn-round btn-primary'>
              Submit
            </Button>
          </div>
        </Row>
      </Form>
    </Layout>
  )
}

export default ChangeConnectionPassword
